var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-3037282e": "",
    "data-v-5405b668": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3858_25468)",
    "data-v-3037282e": ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96909 19.6065C9.2772 19.6065 8.56505 19.5512 7.84861 19.4406C6.58678 19.2455 5.30944 18.5949 4.94799 18.4002L4 17.8894L5.02636 17.5568C6.1483 17.1932 6.8308 16.9677 7.67565 16.6145C6.8297 16.2107 6.17773 15.4844 5.86389 14.5456L5.62511 13.8312L5.82091 13.8607C5.63525 13.6763 5.48864 13.4892 5.37499 13.3189C4.97082 12.7139 4.75683 11.9747 4.80237 11.3412L4.84729 10.7176L5.22607 10.8622C5.06628 10.5649 4.9508 10.2473 4.88293 9.9144C4.71753 9.1026 4.85595 8.24016 5.27282 7.486L5.60278 6.88907L6.04405 7.41141C7.43968 9.06363 9.20737 10.0437 11.3054 10.3306C11.2197 9.7485 11.2839 9.18669 11.4964 8.68311C11.7439 8.09677 12.1841 7.59956 12.769 7.24516C13.4186 6.85165 14.2065 6.66097 14.9874 6.70825C15.8158 6.75842 16.5681 7.06434 17.1654 7.59354C17.4572 7.51884 17.6722 7.43908 17.9627 7.33129C18.1375 7.26645 18.3358 7.19282 18.5838 7.10861L19.4978 6.79823L18.9018 8.47595C18.9411 8.4727 18.9816 8.46994 19.024 8.46814L20.0001 8.42459L19.4231 9.20161C19.3901 9.24612 19.3817 9.25875 19.3699 9.2762C19.3234 9.34525 19.2656 9.43114 18.4737 10.4732C18.2754 10.7341 18.1765 11.074 18.1949 11.4303C18.2651 12.7844 18.0965 14.0096 17.6935 15.0716C17.3125 16.0763 16.7218 16.9384 15.9384 17.6339C14.969 18.4943 13.7327 19.0834 12.264 19.3846C11.5435 19.5324 10.7699 19.6065 9.96909 19.6065Z",
    fill: "currentColor",
    "data-v-3037282e": ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "data-v-3037282e": ""
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3858_25468",
    "data-v-3037282e": ""
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    "data-v-3037282e": ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTwitter);
export default __webpack_public_path__ + "static/media/black-twitter.1fce5ae42e70b8eaf3f5631bd206de53.svg";
export { ForwardRef as ReactComponent };